import { BaseDao } from './BaseDao';
import { ApiHelper } from '../apiHelper';
import { ConstantMan } from '../constantMan';
import { Observable } from 'rxjs';

export class BidDataDao extends BaseDao {
  constructor(apiHelper: ApiHelper) {
    super(ConstantMan.API.RESOURCE.BIDDATA, apiHelper);
  }
}
